import { IReward } from '@nova/types';

export enum DayOfWeekEnum {
  SUN = 0,
  MONDAY = 1,
  TUES = 2,
  WED = 3,
  THUR = 4,
  FRI = 5,
  SAT = 6
}

export type FreshState = 'F' | 'E' | 'D';

export interface IAnswerReward {
  lp: number;
  iReward: IReward | null;
  state: FreshState;
  penalty: number;
}
